<template>
  <div class="rf-config-licenca">
    <template v-if='status !== ""'>
      <RF-Status :cpntStatus='status' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else>
      <div class="rf-div-termos">
        <template v-if='arrAceitar !== null && arrAceitar.length > 0'>
          <p><i class="fa fa-arrow-right" aria-hidden="true"></i>Existe {{ arrAceitar.length }} termo{{ arrAceitar.length > 1 ? 's' : '' }} demonstrativo para {{ arrAceitar.length > 1 ? 'serem' : 'ser' }} aceito{{ arrAceitar.length > 1 ? 's' : '' }}.</p>
          <div>
            <p class="rf-titulo-pacote">
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              Atenção
            </p>
            <div class="rf-valor-pacote">
              <p>
                Para conhecer o Software Rotina Fácil é necessário estar de acordo com o{{ arrAceitar.length > 1 ? 's' : '' }} termo{{ arrAceitar.length > 1 ? 's' : '' }} abaixo:
              </p>

              <p>
                <table class="rf-tabela-aceites">
                  <tr v-for='(aceitar, numAceite) in arrAceitar' :key="numAceite">
                    <td class="rf-buttons">
                      <RF-Toggles :class='"rf-toggles rf-field-tamanho-0"'
                        :cpntStatus='""'
                        :cpntId='"rf-checkbox-termo-demonstrativo-" + numAceite'
                        :cpntNome='""'
                        :cpntValue='aceitar.toggles'
                        :cpntDisabled='false'
                        :cpntMostrar='true'
                        :cpntMensagem='""'
                        :cpntMensagemTipo='""'
                        :cpntOn='"Concordo"'
                        :cpntOff='"---"'

                        :cpntOnChange='changeToggles'
                      ></RF-Toggles>

                      <!-- <RF-Toggles :id='"rf-checkbox-termo-demonstrativo-" + numAceite' :on='"Concordo"' :off='"---"' :vToggles='aceitar.toggles' @changeToggles='changeToggles'></RF-Toggles> -->
                    </td>
                    <td class="rf-termos">
                      <a :href='aceitar.termo_link' target="_blank">
                        <i class="fas fa-file-pdf" aria-hidden="true"></i>
                        Abrir termo demonstrativo {{ numAceite + 1 }}
                      </a>
                    </td>
                  </tr>
                </table>
              </p>
            </div>

            <br/>

            <p style="text-align: left;">
              <RF-Button 
                :cpntId='"salvar-pacotes"'
                :cpntStatus='statusBt' 
                :cpntTexto='"Declaro que li e concordo com todos os termos descritos acima"' 
                :cpntClass='[ "btn", "btn-primary" ]'
                :cpntDisabled='disabledBt'

                @onClickButton='onAceitaContrato'
              ></RF-Button>

              <!-- <RF-Button :btClass='"btn btn-primary "' :vStatusButton='vStatusButton' :type='"text"' :text='"Declaro que li e concordo com todos os termos descritos acima"' @onClickButton='onAceitaContrato'></RF-Button> -->
            </p>

          </div>
        </template>

        <template v-else>
          <template v-if='valValidadeAceite !== null'>
            <p class="rf-titulo-pacote">
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              Termo demonstrativo atual.
            </p>
            <div class="rf-valor-pacote">
              <template v-if='valValidadeAceite <= 0'>
                <i class="far fa-times-circle rf-icon-vermelho" aria-hidden="true"></i>
                Seu contrato demonstrativo esta vencido, para saber mais sobre o contrato de licença de uso do Rotina Fácil <router-link :to='{ name: "contrato_licenca_uso" }'>Clique aqui.</router-link>
              </template>
              <template v-if='valValidadeAceite >= 1'>
                <i class="far fa-check-circle rf-icon-verde" aria-hidden="true"></i>
                Você tem {{ valValidadeAceite }} dia{{ valValidadeAceite > 1 ? 's' : '' }} para testar o Software Rotina Fácil, para saber mais sobre o contrato de licença de uso do Rotina Fácil <router-link :to='{ name: "contrato_licenca_uso" }'>Clique aqui.</router-link>
              </template>
            </div>
          </template>

          <p class="rf-titulo-pacote">
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            Termos aceitos até o momento.
          </p>
          <div class="rf-valor-pacote">
            <table>
              <tr>
                <td style="width: 400px;">
                  <template v-for='(aAceite, vIndex) in jaceites'>
                    <template v-if='aAceite.hasOwnProperty("updated_at_ptbr") && aAceite.updated_at_ptbr !== ""'>
                      <div :class="'rf-info-principal rf-div-ativada-' + (vAberto === vIndex)" :key="vIndex">
                        <RF-Button 
                          :cpntId='"salvar-pacotes"'
                          :cpntStatus='""' 
                          :cpntTexto='"Aceite do termo realizado em " + aAceite.updated_at_ptbr' 
                          :cpntIcone='"far fa-check-circle rf-termo-icon-status rf-icon-verde"'
                          :cpntClass='[ "btn", "btn-default", ("rf-button-ativado-" + (vAberto === vIndex)) ]'

                          @onClickButton='funApresentarAceite(vIndex)'
                        ></RF-Button>

                        <!-- <RF-Button :btClass='"btn btn-default rf-button-ativado-" + (vAberto === vIndex)' :vStatusButton='""' :type='"left-icon-right-text"' :text='"Aceite do termo realizado em " + aAceite.updated_at_ptbr' iconClass='far fa-check-circle rf-termo-icon-status rf-icon-verde' @onClickButton='funApresentarAceite(vIndex)'></RF-Button> -->
                      </div>
                    </template>
                  </template>
                </td>
                <td v-show='vAberto !== ""'>
                  <template v-if='vAberto !== "" && vAberto !== null'>
                    <div class="rf-resumo-termo">
                      <div class="rf-valor-pacote">
                        <div class="rf-termos-titulo-campos">
                          <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                          Informações do aceite
                        </div>
                        <div class="rf-termos-campos">
                          <span class="rf-termo-titulo">Código da Licença de Uso: </span><span class="rf-termo-value">{{ jaceites[vAberto]['clu'] }}</span><br/>
                          <span class="rf-termo-titulo">IP do contratante: </span><span class="rf-termo-value">179.184.56.71</span><br/>
                          <span class="rf-termo-titulo">Usuário On-line que realizou o aceite: </span><span class="rf-termo-value">[{{ jaceites[vAberto]['usu_id'] }}] - {{ jaceites[vAberto]['usu_nome'] }}</span><br/>
                          <span class="rf-termo-titulo">Data e hora do aceite: </span><span class="rf-termo-value">{{ jaceites[vAberto]['updated_at_ptbr'] }}</span>
                        </div>
                        <hr/>

                        <div class="rf-termos-titulo-campos">
                          <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                          Informações da empresa
                        </div>
                        <div class="rf-termos-campos">
                          <span class="rf-termo-titulo">Nome Empresa: </span><span class="rf-termo-value">{{ jaceites[vAberto]['nome'] }}</span><br/>
                          <span class="rf-termo-titulo">CNPJ: </span><span class="rf-termo-value">{{ jaceites[vAberto]['cnpj'] }}</span><br/>
                          <span class="rf-termo-titulo">Inscrição Estadual: </span><span class="rf-termo-value">{{ jaceites[vAberto]['ie'] }}</span><br/>
                          <span class="rf-termo-titulo">Inscrição Municipal: </span><span class="rf-termo-value">{{ jaceites[vAberto]['im'] }}</span><br/>
                          <span class="rf-termo-titulo">Telefone: </span><span class="rf-termo-value">{{ jaceites[vAberto]['telefone'] }}</span><br/>
                          <span class="rf-termo-titulo">Estado: </span><span class="rf-termo-value">{{ jaceites[vAberto]['id_estado'] }}</span><br/>
                          <span class="rf-termo-titulo">Cidade: </span><span class="rf-termo-value">{{ jaceites[vAberto]['cidade'] }}</span><br/>
                          <span class="rf-termo-titulo">CEP: </span><span class="rf-termo-value">{{ jaceites[vAberto]['cep'] }}</span><br/>
                          <span class="rf-termo-titulo">Endereço: </span><span class="rf-termo-value">{{ jaceites[vAberto]['endereco'] }}, {{ jaceites[vAberto]['numero'] }} ({{ jaceites[vAberto]['complemento'] }})</span><br/>
                          <span class="rf-termo-titulo">Bairro: </span><span class="rf-termo-value">{{ jaceites[vAberto]['bairro'] }}</span><br/>
                          <span class="rf-termo-titulo">Site: </span><span class="rf-termo-value">{{ jaceites[vAberto]['site'] }}</span><br/>
                          <span class="rf-termo-titulo">Observações: </span><span class="rf-termo-value">{{ jaceites[vAberto]['obs'] }}</span><br/>
                          <span class="rf-termo-titulo">E-mail: </span><span class="rf-termo-value">{{ jaceites[vAberto]['email_cob'] }}</span>
                        </div>
                        <hr/>

                        <div class="rf-termos-titulo-campos">
                          <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                          Informações do Representante Legal
                        </div>
                        <div class="rf-termos-campos">
                          <span class="rf-termo-titulo">Nome:</span><span class="rf-termo-value">{{ jaceites[vAberto]['rep_leg'] }}</span><br/>
                          <span class="rf-termo-titulo">CPF:</span><span class="rf-termo-value">{{ jaceites[vAberto]['rep_cpf'] }}</span><br/>
                        </div>
                        <hr/>

                        <div class="rf-termos-titulo-campos">
                          <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                          Pacotes contratados
                        </div>
                        <div class="rf-termos-campos">
                          <div class="rf-pacotes-contratados">
                            <div v-for="(pac, index) in jaceites[vAberto].arrPacotesSelected" :key="index">
                              <span v-html='pac.pac_nome'></span>
                              <RF-Explica 
                                :cpntId='"rf-info-pac" + index' 
                                :cpntTitle='pac.j_pac_desc'
                              ></RF-Explica>
                            </div>
                          </div>
                        </div>
                        <hr/>

                        <div class="rf-termos-titulo-campos">
                          <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                          Termo aceito
                        </div>
                        <div class="rf-termos-campos">
                          <RF-Button 
                            :cpntId='"salvar-pacotes"'
                            :cpntStatus='""' 
                            :cpntTexto='"Abrir termo aceito"' 
                            :cpntClass='[ "btn", "btn-default" ]'

                            @onClickButton='funAbrirLink(jaceites[vAberto].termo_link, "_blank")'
                          ></RF-Button>

                          <!-- <RF-Button :vStatusButton='""' :type='"text"' :text='"Abrir termo aceito"' @onClickButton='funAbrirLink(jaceites[vAberto].termo_link, "_blank-sem-menu")'></RF-Button> -->
                        </div>
                        <hr/>
                      </div>

                      <br/>
                    </div>
                  </template>
                </td>
              </tr>
            </table>
          </div>
        </template>

      </div>
    </template>
  </div>
</template>

<style scoped>
  .rf-titulo-pacote {
    padding-top: 15px;
    font-weight: bold;
  }
  .rf-valor-pacote {
    padding-left: 15px;    
  }
    .rf-valor-pacote > p {
      text-align: justify;
    }

  .rf-config-licenca {
    padding: 15px 20px 15px 20px !important;
  }

  .rf-loading-form {
    text-align: center;
    padding: 30px 0px 30px 0px;
  }
    .rf-loading-form > svg {
      font-size: var(--font-base-soma-90);
      color: var(--color-base-05);
    }
    .rf-loading-form > div {
      margin-top: 15px;
    }
  /* -------------------------------------- */
  .rf-div-termos {
    padding-top: 15px;
  }
    .rf-div-termos > p > svg {
      margin-right: 5px;
      color: #717171;
    }
    .rf-div-termos > div {
      padding-left: 20px;
      padding-right: 25px;
      clear: both;
    }

    .rf-tabela-aceites {
    }
    .rf-tabela-aceites > tr {
    }
      .rf-tabela-aceites > tr > td.rf-buttons {
        padding: 5px 0px;

        width: 120px;
        text-align: center;
      }
        .rf-tabela-aceites > tr > td.rf-buttons > .rf-input-group {
          margin-bottom: 0px;
        }
      .rf-tabela-aceites > tr > td.rf-termos {
        padding-left: 5px;
      }
        .rf-tabela-aceites > tr > td.rf-termos > a {
          color: #337ab7;
          text-decoration: none;
        }
        .rf-tabela-aceites > tr > td.rf-termos > a:hover {

        }
          .rf-tabela-aceites > tr > td.rf-termos > a > svg {
            font-size: var(--font-base-soma-20);
            vertical-align: -2px;
          }
    .rf-valor-pacote > hr {
      margin: 3px 0px 10px 0px;
    }
    .rf-valor-pacote > .rf-termos-titulo-campos {
      font-size: var(--font-base-soma-14);
      font-weight: 500;
      font-style: italic;
    }
      .rf-valor-pacote > .rf-termos-titulo-campos > svg {
        margin-right: 8px;
      }

    .rf-valor-pacote > .rf-termos-campos {
      padding-left: 25px;
    }
      .rf-valor-pacote > .rf-termos-campos > .rf-termo-titulo {
        font-weight: 600;
        margin-right: 5px;
      }
      .rf-valor-pacote > .rf-termos-campos > .rf-termo-value {
      }

    .rf-valor-pacote > table > tr > td {
      vertical-align: top;
    }

    .rf-valor-pacote > table {
      width: 100%;
    }
    .rf-valor-pacote > table > tr > td:nth-last-child(1) {
      background: #fcfdfd;
      border: 1px solid #ccc;
      padding: 15px 0px;

      -webkit-box-shadow: 5px 5px 5px 0px rgba(133,133,133,0.4);
      -moz-box-shadow: 5px 5px 5px 0px rgba(133,133,133,0.4);
      box-shadow: 5px 5px 5px 0px rgba(133,133,133,0.4);
    }
    .rf-valor-pacote > table > tr > td > div > button.rf-button-ativado-true {
      color: var(--color-base-01);
      background-color: #d4d4d4;
      border-color: #8c8c8c;

      background-image: none;
    }

    .rf-pacotes-contratados > div {
      display: inline-block;
      text-align: center;
      background-color: #f2f6f9;
      padding: 5px 10px;
      border-radius: 5px;
      min-width: 100px;
      margin: 5px;
      border: 1px solid #ddd;

      -webkit-box-shadow: 1px 1px 1px 0px rgba(133,133,133,0.4);
      -moz-box-shadow: 1px 1px 1px 0px rgba(133,133,133,0.4);
      box-shadow: 1px 1px 1px 0px rgba(133,133,133,0.4);
    }

    .rf-div-ativada-false {
      padding: 10px 0px 10px 10px;
    }
    .rf-div-ativada-true {
      background: #fcfdfd;
      border: 1px solid #ccc;
      padding: 10px 0px 10px 10px;
      border-right: none;
      position: relative;
      left: 1px;
    }
    .rf-info-principal > button:focus {
      outline: none;
      color: var(--color-base-01);
      background-color: #fff;
      border-color: #ccc;
    }
</style>
<style>
  div.rf-info-principal > button > svg {
    font-size: var(--font-base-soma-18);
  }
  div.rf-info-principal > button > div {
    display: inline-block;
  }
</style>

<script>
  import { SESSAO_ATUALIZAR_TOKEN } from '@/assets/js/Sessao.js'

  export default {
    components: {
      'RF-Toggles': () => import('@/components/rf-geral/toggles/RF-Toggles.vue'),
      'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    data: function () {
      return {
        statusBt: '',
        disabledBt: false,
        status: '',

        aAceite: {},
        aCheckbox: [],
        vContrato: '',
        arrAceitar: [],
        jaceites: [],
        vAberto: '',
        arrMensagem: [],
        arrPacotes: [],
        valValidadeAceite: null,

        valSimbolo: 'R$',
        valLic: '',
        valUsu: '',
        valTax: ''
      }
    },
    mounted: function () {
      if (this.$store.state.token.clu_con !== 'l' && this.$store.state.token.clu_con !== 'lv') {
        this.getPacotesExistentes()
      } else {
        this.$router.push({ name: 'erro_perfil' })
      }
    },
    methods: {
      getIniciarContrato: function () {
        var self = this

        self.aAceite = {}

        // SETA O STATUS DE CARREGANDO SELECT
        self.status = 'carregando'

        // CHAMA FUNÇÃO PARA PEGAR OS DADOS NA API
        self.$store.state.comunicaAPI('/subase/termo/get/demonstrativo', 'GET', null, function (apiSuccess) {
          if (apiSuccess.data.hasOwnProperty('j_aceitar') && apiSuccess.data.j_aceitar === null) {
            self.status = { aCod: '999', aErr: 'OPS! Nenhum contrato encontrado para aceitar. Por favor entrar em contato com nosso suporte pelo telefone 41 3076-7488 ou pelo e-mail <a href="mailto:atendimento@subase.com.br">atendimento@subase.com.br</a>.' }
          } else if (apiSuccess.data.hasOwnProperty('j_aceitar') && apiSuccess.data.j_aceitar !== null) {
            self.arrAceitar = apiSuccess.data.j_aceitar

            for (var key1 in self.arrAceitar) {
              self.arrAceitar[key1]['toggles'] = false
            }

            // RETIRA O LOADING DA PAGINA
            self.status = ''

            // CHAMA A FUNÇÃO PARA ATUALIZAR O STATUS DO BUTTON
            self.funVerificaStatusButton()

            // CHAMA A FUNÇÃO PARA CALCULAR O VALOR DA LICENÇA DE USO
            self.onUpdateValores()
          } else if (apiSuccess.data.hasOwnProperty('j_aceites') && apiSuccess.data.j_aceites !== null) {
            self.vAberto = ''
            self.jaceites = []

            for (var key2 in apiSuccess.data.j_aceites) {
              var arrPacotesSelected = []

              for (var kPcc in apiSuccess.data.j_aceites[key2]['clu_pcc']) {
                var objPacotes = self.arrPacotes.filter(item => item.pac_id === apiSuccess.data.j_aceites[key2]['clu_pcc'][kPcc])

                if (objPacotes.length >= 0 && objPacotes[0].pac_id !== 1) {
                  arrPacotesSelected.push(objPacotes[0])
                }
              }

              // ORDENA O VETOR COM OS PACOTES DISPONIVEIS
              arrPacotesSelected = arrPacotesSelected.sort(function (a, b) {
                return a.pac_nome < b.pac_nome ? -1 : a.pac_nome > b.pac_nome ? 1 : 0
              })

              apiSuccess.data.j_aceites[key2]['arrPacotesSelected'] = arrPacotesSelected
            }

            // RETIRA O LOADING DA PAGINA
            self.status = ''

            // var ordered = {}
            Object.keys(apiSuccess.data.j_aceites).sort().forEach(function (key) {
              self.jaceites.push(apiSuccess.data.j_aceites[key])
            })

            // INVERTE O VETOR
            self.jaceites.reverse()

            // SETA QUAL É O CONTRATO QUE DEVE ABRIR
            self.vAberto = 0

            // SALVA O NUMERO DE DIAS QUE FALTA PARA VENCER O CONTRATO
            self.valValidadeAceite = apiSuccess.data.validade_nd
          }
        }, function (apiError) {
          // ERRO AO PEGAR DADOS NA API
          self.status = apiError
        })
      },
      onAceitaContrato: function () {
        var self = this

        // COLOCA O BOTÃO COMO LOADING
        self.statusBt = 'carregando'

        // PEGA TODOS OS TERMOS QUE FORAM SELECIONADOS
        var arrAceitar = self.arrAceitar.filter(item => item.toggles === true)

        // ATUALIZA O STATUS DO BOTÃO
        if (arrAceitar.length === self.arrAceitar.length) {
          var formData = {}
          formData['tipo'] = 'demonstrativo'

          // CHAMA FUNÇÃO PARA ACEITAR O CONTRATO
          self.$store.state.comunicaAPI('/subase/termo', 'PUT', formData, function () {
            SESSAO_ATUALIZAR_TOKEN('clu_con', function () {
              setTimeout(function () {
                setTimeout(function () {
                  self.$store.state.msgWarn('API [200]: Parabéns! Agora você pode experimentar as funcionalidades do Software Rotina Fácil. Qualquer dúvida utilize o nosso chat ou envie e-mail para atendimento@subase.com.br', 'success')
                }, 300)

                self.getPacotesExistentes()
              }, 700)
            })
          }, function (apiError) {
            self.status = apiError
          })
        } else {
          self.$store.state.msgWarn('WEB [409]: É necessario aceitar todos os termos antes de proceguir.', 'danger')
          self.statusBt = ''
        }
      },
      funApresentarAceite: function (vIndex) {
        if (this.vAberto === vIndex) {
          this.vAberto = ''
        } else {
          this.vAberto = vIndex
        }
      },
      funAbrirLink: function (vLink, vTarget) {
        this.$store.state.OPEN_PAGE_CS(vLink, vTarget, {}, false)
      },
      funVerificaStatusButton: function () {
        // PEGA TODOS OS TERMOS QUE FORAM SELECIONADOS
        var arrAceitar = this.arrAceitar.filter(item => item.toggles === true)

        // ATUALIZA O STATUS DO BOTÃO
        if (arrAceitar.length === this.arrAceitar.length) {
          // this.statusBt = ''
          this.disabledBt = false
        } else {
          // this.statusBt = 'disabled'
          this.disabledBt = true
        }
      },
      changeToggles: function (value, id) {
        // PEGA O INDEX DO VETOR QUE ESTA SENDO ALTERADO
        var numIndex = Number(id.substring('rf-checkbox-termo-demonstrativo-'.length))

        // SETA O NOVO VALOR PARA O INDEX INFORMADO
        this.arrAceitar[numIndex]['toggles'] = value

        // CHAMA A FUNÇÃO PARA ATUALIZAR O STATUS DO BUTTON
        this.funVerificaStatusButton()
      },
      getPacotesExistentes: function () {
        var self = this

        // VERIFICA SE DEVE APRESENTAR AS INFORMAÇOES
        self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])

        self.status = 'carregando'

        self.statusBt = ''
        self.disabledBt = false
        // self.status = ''

        self.aAceite = {}
        self.aCheckbox = []
        self.vContrato = ''
        self.arrAceitar = []
        self.jaceites = []
        self.vAberto = ''
        self.arrMensagem = []
        self.arrPacotes = []
        self.valValidadeAceite = null

        self.valSimbolo = 'R$'
        self.valLic = ''
        self.valUsu = ''
        self.valTax = ''

        // RESETA TODAS AS MENSAGENS EXISTENTES
        self.arrMensagem = []

        self.$store.state.comunicaAPI('/subase/pacote/get', 'GET', null, function (apiSuccess) {
          for (var valKeyPac in apiSuccess.data) {
            if (self.$store.state.token.clu_pcc.filter(item => item.toString() === apiSuccess.data[valKeyPac].pac_id).length > 0) {
              if (apiSuccess.data[valKeyPac].ti_desc !== '' && apiSuccess.data[valKeyPac].ti_desc !== null) {
                self.arrMensagem.push('<b>Taxa Inscrição ' + apiSuccess.data[valKeyPac].pac_nome + '</b>: ' + apiSuccess.data[valKeyPac].ti_desc)
              }

              if (apiSuccess.data[valKeyPac].lu_desc !== '' && apiSuccess.data[valKeyPac].lu_desc !== null) {
                self.arrMensagem.push('<b>Pacote ' + apiSuccess.data[valKeyPac].pac_nome + '</b>: ' + apiSuccess.data[valKeyPac].lu_desc)
              }
            }

            // SALVA OS PACOTES RECEBIDOS
            var arrPacDescricao = JSON.parse(apiSuccess.data[valKeyPac]['j_pac_desc'])

            // ZERA AS DECRIÇÕES RECEBIDAS
            apiSuccess.data[valKeyPac]['j_pac_desc'] = ''

            // SETA OS DADOS DO TOOLTIP
            for (var keyDesc in arrPacDescricao) {
              apiSuccess.data[valKeyPac]['j_pac_desc'] += arrPacDescricao[keyDesc]
              apiSuccess.data[valKeyPac]['j_pac_desc'] += '<br/><br/>'
            }
          }

          // RETIRA O LOADING DA PAGINA
          self.status = ''

          self.arrPacotes = apiSuccess.data

          self.getIniciarContrato()
        }, function (apiError) {
          self.status = apiError
        })
      },
      onUpdateValores: function () {
        this.valTax = 0
        this.valLic = 0
        this.valUsu = 0

        this.valUsu += Number(this.$store.state.licenca.valor_ua.replace(',', ''))
        for (var key in this.arrPacotes) {
          if (this.$store.state.token.clu_pcc.filter(item => item.toString() === this.arrPacotes[key].pac_id).length > 0) {
            this.valTax += this.arrPacotes[key].ti_valor
            this.valLic += this.arrPacotes[key].lu_valor
          }
        }

        if (this.valTax === '' || this.valTax === 0 || this.valTax === '0') {
          this.valTax = '0,00'
        } else {
          this.valTax = ((this.valTax) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.valTax = this.valTax.replace('.', ',')
        }
        this.valTax = this.valTax

        if (this.valLic === '' || this.valLic === 0 || this.valLic === '0') {
          this.valLic = '0,00'
        } else {
          this.valLic = ((this.valLic) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.valLic = this.valLic.replace('.', ',')
        }
        this.valLic = this.valLic

        if (this.valUsu === '' || this.valUsu === 0 || this.valUsu === '0') {
          this.valUsu = '0,00'
        } else {
          this.valUsu = ((this.valUsu) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.valUsu = this.valUsu.replace('.', ',')
        }
        this.valUsu = this.valUsu
      }
    }
  }
</script>
